import { ProductViewModel } from '@/types/cml-api'

import { HomePageCardProps } from '../types'

export const generateHomepageCardProps = (product: ProductViewModel, isPinkBox: boolean): HomePageCardProps => ({
    brand: product.brand?.nameFa || product.brand?.nameEn || '',
    name: product.nameFa || product.nameEn || '',
    id: product.id || '',
    image: product.mainImageUrl || '',
    slug: product.slug || '',
    pricingProps: {
        basePrice: product.basePrice || 0,
        discountPercent: product.discountPercent || 0,
        effectivePrice: product.salesPrice || 0,
    },
    isSalable: product.isSalable || false,
    type: isPinkBox ? 'pink-box' : 'product-list',
})
